import {combineReducers} from 'redux';
import fuse from './fuse';
import auth from 'modules/auth/store/reducers';
import quickPanel from 'client/app/quickPanel/store/reducers';

const createReducer = (asyncReducers) =>
    combineReducers({
        auth,
        fuse,
        quickPanel,
        ...asyncReducers
    });

export default createReducer;
